import React from "react";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import Footer from "../components/footer/Footer";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import OurServices from "../components/our-services/OurServices";
import FAQ from "../components/Fqas/FAQ";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import DarkRoadMap from "../components/dark-roadmap/darkRoadMap";
import SimpleModels from "../components/simpleEngagementModels";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import tabData from "../data/industryData";
import { useTranslation } from "react-i18next";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import NewBenefitsSection from "../components/new-banefits-section/NewBenefitsSection";
import IndustriesTabs from "../components/industries-tabs/IndustriesTabs";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import ChatBotWorkFlow from "../components/chatbbot-workflow/ChatBotWorkFlow";
import IntigrationIconsSection from "../components/integration-icons-section/IntigrationIconsSection";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import AreasWeServe from "../components/areas-we-serve/AreasWeServe";
import { AiChatBotPageDataFlorida } from "../data/ai-chatbot-data-florida";
import TechStack from "../components/techstack/TechStack";
import { aiContactData } from "../data/aiContactSectionData";
import ChatbotIntigratedSection from "../components/ChatBotIntigratedSection/ChatbotIntigratedSection";
import SecurityFIrstSection from "../components/SecurityFirstSection/SecurityFIrstSection";
import NewRoadMap from "../components/new-raodmap-section/NewRoadMap";
import ModelAgnostic from "../components/ModelAgnostic/ModelAgnostic";
import { AiChatBotPageData } from "../data/ai-chatbot-data";
import ChatbotBanner from "../components/ChatbotBanner/ChatbotBanner";

const AIChatBotServicesFlorida = () => {

    const { t } = useTranslation("footer");
    const footerCtaContent = t("footerCtaContent", { returnObjects: true });

    const { t: stackData } = useTranslation("aiDevelopmentPageContent");
    const coverTheStackData = stackData("aiDevCoverTheStackSection", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>Florida AI Chatbot Development Agency | Bitsclan</title>
                <meta
                    name="description"
                    content="Hire top AI chatbot developers in Florida. Our expert team builds smart chatbots for automation, lead generation and customer support for scalable growth and efficiency."
                />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <link rel="canonical" href="https://bitsclan.com/florida-ai-chatbot-development-agency" />
            </Helmet>

            <MegaMenu />

            <ChatbotBanner
                shortHeading="AI-Powered Chatbot Development Company in Florida"
                mainHeading="Strategic <span>Chatbot Platforms</span> Designed for Business Transformation in Florida"
                description="Get ahead with our AI chatbot development agency in Florida. Automate workflows, improve engagement, & save money. Hire AI chatbot developers in Florida to develop customized AI solutions that build growth & make your business ready for the future."
                bannerImage="/images/why-us-section/chatbot-banner.png"
            />

            <TrustedPartner category={"chatbot"} showGoogleIcons={true} heading="Trusted & Partnered by Businesses Worldwide to Build Smarter Chatbot Solutions" />

            <OurServices
                shortHeading={"Our AI Chatbot Development Services in Florida"}
                buttonText="Let’s Build an AI Chatbot"
                servicesCardsData={AiChatBotPageDataFlorida?.services}
                mainHeading="Custom Chatbot Solutions Driving Operational Excellence & Business Growth"
                // mainHeading=" No Matter What You are Building, We Can Help with Expert <span>AI Solutions</span>"
                description="Our custom AI chatbot development services give businesses worldwide a competitive advantage by providing improved customer engagement, improved operations & increased efficiency. As the leading AI chatbot development agency located in Florida, you can contact us at any time to discuss your needs with one of our 24/7 hours consultants."
            />

            <NewTestimonials
                shortHeading={AiChatBotPageDataFlorida?.testimonialData?.shortHeading}
                mainHeading={AiChatBotPageDataFlorida?.testimonialData?.mainHeading}
                description={AiChatBotPageDataFlorida?.testimonialData?.description}
                content={AiChatBotPageDataFlorida?.testimonialData?.testimonials}
            />

            <WhyChooseUs
                heading={AiChatBotPageDataFlorida?.whyUsSectionData?.heading}
                greenHeading={AiChatBotPageDataFlorida?.whyUsSectionData?.greenHeading}
                content={AiChatBotPageDataFlorida?.whyUsSectionData?.content}
                shortHeading={AiChatBotPageDataFlorida?.whyUsSectionData?.shortHeading}
                stats={AiChatBotPageDataFlorida?.whyUsSectionData?.stats}
                cta={AiChatBotPageDataFlorida?.whyUsSectionData?.cta}
                sectionImage={AiChatBotPageDataFlorida?.whyUsSectionData?.image}
            />

            <NewCaseStudySection
                heading={AiChatBotPageDataFlorida?.caseStudyContent?.heading}
                shortHeading={AiChatBotPageDataFlorida?.caseStudyContent?.shortHeading}
                description={AiChatBotPageDataFlorida?.caseStudyContent?.description}
                filter={"chatbot"}
            />

            <ChatbotIntigratedSection content={AiChatBotPageData?.integrationsData} />

            <SimpleModels content={AiChatBotPageData?.engagementModels} />

            <TechStack content={AiChatBotPageData?.techStackData} />

            <NewBenefitsSection />

            {/* <ChatBotWorkFlow />

            <IntigrationIconsSection content={AiChatBotPageDataFlorida?.chatbotIntigration} /> */}

            <PioneeringChange
                shortHeading="Industries We Serve"
                tabData={AiChatBotPageDataFlorida?.industriesSectionMain}
                greenHeading={"Solutions Built for the Unique Demands of Every Industry"}
                mainHeading={"Specialized Chatbot "}
                content={"Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights."}
                serviceTags={[
                    { title: "AI Chatbots", link: "/ai-chatbot-development-services" },
                    { title: "Virtual Assistants", link: "/ai-automation-agency" },
                    { title: "Conversational AI", link: "/generative-ai-development-services" }
                ]}
            />

            {/* <IndustriesTabs defaultTab={"Healthcare"} shortHeading="Industries We Serve" mainheading="Our Industry-Specific Chatbot Development Expertise" description="Driving innovation & transforming industries with advanced ai chatbot development expertise & actionable insights." /> */}

            <SecurityFIrstSection />

            <ModelAgnostic />

            <CoverTheStack
                whereStart={"Deep learning frameworks"}
                shortHeading={"Technology Stack for Chatbot Development"}
                mainHeading={"Foundational Technologies Driving Conversational Intelligence"}
                subHeading={
                    "The right technology stack for chatbot development will depend on your intended use cases & channels. We engage with the leading providers from Microsoft Azure & AWS to Google Cloud for dependable, secure, & scalable solutions."
                }
                tabs={AiChatBotPageDataFlorida?.techStack?.tabs}
                tabItems={AiChatBotPageDataFlorida?.techStack?.tabItems}
            />

            <NewRoadMap roadmapContent={AiChatBotPageData?.roadmapContent} />

            <TrendsInsights
                category="ai-developmet"
                heading={AiChatBotPageDataFlorida?.trendingInsights.heading}
                description={AiChatBotPageDataFlorida?.trendingInsights.description}
            />

            <FAQ
                faqs={AiChatBotPageDataFlorida.faqSection.questionAnswers}
                mainHeading={AiChatBotPageDataFlorida.faqSection.heading}
            />

            <AreasWeServe />

            <SoftwareCompanyCta content={AiChatBotPageDataFlorida?.companyCta} />
            <Footer />
        </>
    )
}

export default AIChatBotServicesFlorida